import {Action, ActionReducerMap} from '@ngrx/store';
import {
    BENUTZER_SUCHEN,
    BenutzerSuchenAction,
    PAGE_STATE_RESET,
    PageStateResetAction, SETZE_BENUTZER_ANZEIGEN, SETZE_KONTAKTE_ANZEIGEN, TOGGLE_FUNKTIONSBEREICHE_ACTION, ToggleFunktionsbereicheAction
} from './dienstplan.actions.ui';

import { APP_RESET_ACTION } from '@orga-app/appstart/actions';
import {DienstplanFunktionsbereich2} from '../../../../clients/veranstaltungen-dienstplan';
import {GET_VERANSTALTUNG_DIENSTPLAN2, GET_VERANSTALTUNG_DIENSTPLAN2_ERFOLGREICH, GET_VERANSTALTUNG_DIENSTPLAN2_FEHLER, GetVeranstaltungDienstplan2Action, GetVeranstaltungDienstplan2ErfolgreichAction} from '../../../../client-ngrx/veranstaltungen-dienstplan';


export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};

export interface PageState {
    dienstplanFunktionsbereiche: Array<DienstplanFunktionsbereich2>;
    uiZeigeDienstplanFunktionsbereicheLaden: boolean;
    uiZeigeDienstplanFunktionsbereicheLadefehler: boolean;

    filterString: string;

    benutzerAnzeigen: boolean;
    kontakteAnzeigen: boolean;

    inaktiveFunktionsbereiche: Array<string>;
}

export const initialPageState: PageState = {
    dienstplanFunktionsbereiche: null,
    uiZeigeDienstplanFunktionsbereicheLaden: false,
    uiZeigeDienstplanFunktionsbereicheLadefehler: false,

    filterString: '',

    benutzerAnzeigen: true,
    kontakteAnzeigen: true,

    inaktiveFunktionsbereiche: []
};

export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState> initialPageState);
        }

        // Page State Reset
        case PAGE_STATE_RESET: {
            const a = <PageStateResetAction> action;

            return Object.assign({}, state, <PageState> initialPageState);
        }

        // Dienstplan mit Funktionsbereichen laden
        case GET_VERANSTALTUNG_DIENSTPLAN2: {
            const a = <GetVeranstaltungDienstplan2Action> action;

            return Object.assign({}, state, <PageState> {
                uiZeigeDienstplanFunktionsbereicheLaden: true
            });
        }

        case GET_VERANSTALTUNG_DIENSTPLAN2_ERFOLGREICH: {
            const a = <GetVeranstaltungDienstplan2ErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                dienstplanFunktionsbereiche: a.payload,
                uiZeigeDienstplanFunktionsbereicheLaden: false,
                uiZeigeDienstplanFunktionsbereicheLadefehler: false
            });
        }

        case GET_VERANSTALTUNG_DIENSTPLAN2_FEHLER: {
            return Object.assign({}, state, <PageState> {
                uiZeigeDienstplanFunktionsbereicheLaden: false,
                uiZeigeDienstplanFunktionsbereicheLadefehler: true
            });
        }

        case BENUTZER_SUCHEN: {
            const a = <BenutzerSuchenAction> action;

            return Object.assign({}, state, <PageState> {
                filterString: a.filterString
            });
        }

        case SETZE_BENUTZER_ANZEIGEN: {
            return Object.assign({}, state, <PageState> {
                benutzerAnzeigen: !state.benutzerAnzeigen
            });
        }

        case SETZE_KONTAKTE_ANZEIGEN: {
            return Object.assign({}, state, <PageState> {
                kontakteAnzeigen: !state.kontakteAnzeigen
            });
        }

        case TOGGLE_FUNKTIONSBEREICHE_ACTION: {
            const a = <ToggleFunktionsbereicheAction>action;

            let res = [...state.inaktiveFunktionsbereiche];
            if(res.includes(a.fbId)){
                res = res.filter((x) => x !== a.fbId);
            } else {
                res.push(a.fbId);
            }

            return Object.assign({}, state, <PageState> {
                inaktiveFunktionsbereiche: res
            });
        }

        default: {
            return state;
        }
    }
}
